import { Component, Input } from '@angular/core';
import { OperationTableRowComponent } from '@components/operation-table-row/operation-table-row.component';
import { OpsOperationsComponent } from '@pages/ops-alarm/ops-operations/ops-operations.component';
import { OperationsHistoryData } from 'ops/common/models/operations-history-data';

@Component({
    selector: 'app-operation-detail-overlay',
    templateUrl: './operation-detail-overlay.component.html',
    styleUrls: [
        './operation-detail-overlay.component.css',
        '../alarm-monitoring-detail-overlay/alarm-monitoring-detail-overlay.component.css',
    ],
    standalone: false
})
export class OperationDetailOverlayComponent extends OperationTableRowComponent {
    @Input() operation: OperationsHistoryData;

    style = {
        display: 'none',
    };

    public setVisible(visible: boolean) {
        this.style.display = visible ? 'flex' : 'none';
    }
}
